import React from 'react';

import type { ICustomOptionProps } from 'common/components/FieldGenerator/types';
import CachedImage from 'common/components/CachedImage';

import styles from './styles.module.scss';

const SelectOption = React.memo<ICustomOptionProps>(({
  option: { title, attributes },
}) => (
  <>
    {attributes?.image && (
      <div className={styles.image}>
        <CachedImage
          src={attributes?.image}
          alt={title}
        />
      </div>
    )}
    <div className={styles.content}>
      <span>{title}</span>
      {attributes?.details && <span className={styles.more}>{attributes?.details}</span>}
    </div>
  </>
), (prevProps, nextProps) => (
  // Custom comparison: only re-render if the option id or key properties change
  prevProps.option.id === nextProps.option.id
  && prevProps.option.title === nextProps.option.title
  && prevProps.option.attributes?.image === nextProps.option.attributes?.image
  && prevProps.option.attributes?.details === nextProps.option.attributes?.details
));

SelectOption.displayName = 'SelectOption';

export default SelectOption;
